import { useQuery } from '@tanstack/react-query';

import { publishedTermsApi } from '../api/public-terms.adapter';

export const publishedTermsQueryKeys = {
  all: ['public-terms'] as const,
};

// FEATURE_041 — public PUBLISHED terms for the login/signup footer viewer. No token.
// The list rarely changes (BE serves it through a shared cache, evicted on publish), so a
// short staleTime avoids re-fetching when the same visitor opens several footer links.
export function usePublishedTermsQuery() {
  return useQuery({
    queryKey: publishedTermsQueryKeys.all,
    queryFn: () => publishedTermsApi.listPublishedTerms(),
    retry: false,
    staleTime: 5 * 60 * 1000,
  });
}
